// extracted by mini-css-extract-plugin
module.exports = {"layout":"_02712f2b3b--layout--tMgCM"};